// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1yvLU","notes":"Notes_notes__QUpb2","note":"Notes_note__2GpJG","markdown":"Notes_markdown__Zqb1V"};